import axios from 'axios';
import endpointNames from "../configs/serverUrls";

const baseUrl = endpointNames.allocate.funeral;
// get User Token
let user = JSON.parse(localStorage.getItem('user'));
//gets token from localStorage
let token = JSON.parse(localStorage.getItem('token'));

//allocate plan
const addFuneralPlan = async (request) => {
    let response;
    await axios.post(baseUrl+'allocate-funeral',request,{

        headers: {Authorization: `Bearer ${token}`},
    })
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

//delete beneficiary
const deleteBeneficiary = async (beneficiaryId) => {
    let response;
    await axios.post(baseUrl+'beneficiary/'+beneficiaryId)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

//get all policies
const getAllPolicies = async () => {
    let response;
    await axios.get(baseUrl+'get-all-funeral-policies/0/100')
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

//add beneficiary
const addBeneficiary = async (request) => {
    let response;
    await axios.post(baseUrl+'beneficiary',request)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

//add beneficiary death
const addBeneficiaryDeath = async (request) => {
    let response;
    await axios.post(baseUrl+'beneficiary/death',request)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

//get all beneficiary policies
const getBeneficiariesPolicies = async (policyNumber) => {
    let response;
    await axios.get(baseUrl+'beneficiaries-policies/'+policyNumber)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

//get dependencies
const getDependents = async (policyNumber) => {
    let response;
    await axios.get(baseUrl+'dependents/'+policyNumber)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

//get beneficiaries
const getBeneficiaries = async (id) => {
    let response;
    await axios.get(baseUrl+'beneficiaries/'+id)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

//get funeral-policy dependencies
const getFuneralPolicyDependents = async (id) => {
    let response;
    await axios.get(baseUrl+'funeral-policy/dependents/'+id)
        .then(res => {
            console.log(res);
            response = res;
        })
        .catch(err => {
            console.log(err);
            response = err;
        });

    return response;
}

export default {
    addBeneficiaryDeath,addBeneficiary,addFuneralPlan,getBeneficiaries,getBeneficiariesPolicies
    ,getDependents,getFuneralPolicyDependents,getAllPolicies, deleteBeneficiary
}
